const accountingReducer = (state = {}, action) => {
    switch (action.type) {
        case 'GET_ACCOUNTING_RESOURCE':
            return Object.assign({}, state, {
                data: null,
                isLoading: true,
                error: false,
                errorMessage: null,
                resource: action.data.resource
            });
        case 'DONE_GET_ACCOUNTING_RESOURCE':
            return Object.assign({}, state, {
                data: action.data,
                isLoading: false,
                error: false,
                errorMessage: null
            });
        case 'ERROR_GET_ACCOUNTING_RESOURCE':
            return Object.assign({}, state, {
                data: null,
                isLoading: false,
                error: true,
                errorMessage: action.data
            });
        case 'CREATE_ACCOUNTING_RESOURCE':
            return Object.assign({}, state, {
                create: null,
                isLoading: true,
                error: false,
                errorMessage: null,
                resource: action.data.resource
            });
        case 'DONE_CREATE_ACCOUNTING_RESOURCE':
            return Object.assign({}, state, {
                create: action.data,
                isLoading: false,
                error: false,
                errorMessage: null,
            });
        case 'ERROR_CREATE_ACCOUNTING_RESOURCE':
            return Object.assign({}, state, {
                create: null,
                isLoading: false,
                error: true,
                errorMessage: action.data
            });
        case 'DELETE_ACCOUNTING_RESOURCE':
            return Object.assign({}, state, {
                deleteResource: null,
                isLoading: true,
                error: false,
                errorMessage: null
            });
        case 'DONE_DELETE_ACCOUNTING_RESOURCE':
            return Object.assign({}, state, {
                deleteResource: true,
                isLoading: false,
                error: false,
                errorMessage: null
            });
        case 'ERROR_DELETE_ACCOUNTING_RESOURCE':
            return Object.assign({}, state, {
                deleteResource: null,
                isLoading: false,
                error: true,
                errorMessage: action.data
            });
        case 'RESET_ACCOUNTING_RESOURCE':
            return Object.assign({}, state, {
                data: null,
                create: null,
                isLoading: false,
                error: false,
                errorMessage: null,
                showRedirectDialog: false
            });
        case 'UPDATE_ACCOUNTING_RESOURCE':
            return Object.assign({}, state, {
                update: null,
                isLoading: true,
                error: false,
                errorMessage: null
            });
        case 'DONE_UPDATE_ACCOUNTING_RESOURCE':
            return Object.assign({}, state, {
                update: true,
                isLoading: false,
                error: false,
                errorMessage: null,
                updated: action.data?.id
            });
        case 'ERROR_UPDATE_ACCOUNTING_RESOURCE':
            return Object.assign({}, state, {
                update: null,
                isLoading: false,
                error: true,
                errorMessage: action.data
            });
        default:
            return state;
    }
};

export default accountingReducer;